<div>
  @if (isLoading) {
  <aw-spinner [fullScreen]="true"></aw-spinner>
  }
  <aw-toast></aw-toast>
  <aw-login
    [appName]="'Security Manager'"
    [primaryLoginKey]="'email'"
    [disableFormSubmission]="false"
    [formFieldsData]="formData"
    [enablePasswordChangeForm]="false"
    [appVersion]="'1.0.0'"
    [loginBgImage]="'../../../../assets/login_image_eam.jpg'"
    [showExternalLoginButton]="true"
    [onExternalLoginClick]="msalLoginclickbinded"
    [enableForgotPassword]="false"
    (submittedFormValues)="loginEmployee($event)"
  >
  </aw-login>
</div>
